import { Box, makeStyles } from '@material-ui/core';
import React from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import TableHeader from '../../../../../theme/components/TableHeader/TableHeader';
import { INITIAL_FILTER_STATE } from '../BeneficiosMGMTableConstants';
import styles from '../BeneficiosMGM.style';

const useStyles = makeStyles(styles);

export const BeneficiosMGMParametrosFilters = props => {
  const { filters, setFilters, hasFastFilterSelected, setSelectedFilter } = props;
  const classes = useStyles(props);

  const handleChangeFilter = (filter, value) => {
    const newFilters = hasFastFilterSelected ? { ...INITIAL_FILTER_STATE } : { ...filters };

    newFilters[filter] = value;
    setFilters({ ...newFilters });
    setSelectedFilter(undefined);
  };

  const handleFilterReferenceDate = (date, filter) => {
    const jsDate = new Date(date);
    const dateParsed = DateTime.fromJSDate(jsDate).toFormat('yyyy-MM-dd');
    handleChangeFilter(filter, dateParsed);
  };

  return (
    <TableHeader.Filters>
      <Box sx={{ display: 'flex', width: '100%', justifyContent: 'start' }}>
        <TableHeader.Input>
          <KeyboardDatePicker
            disableToolbar
            className={classes.datePicker}
            label="Data inicial"
            InputLabelProps={{
              style: { color: 'rgba(0, 0, 0, 0.6)' },
            }}
            value={DateTime.fromISO(filters.created_on).toISO()}
            onChange={newDate => handleFilterReferenceDate(newDate, 'created_on')}
            format="dd/MM/yyyy"
            initialFocusedDate={DateTime.local().startOf('day')}
            maxDate={DateTime.local().endOf('year')}
            views={['date']}
          />
        </TableHeader.Input>

        <TableHeader.Input>
          <KeyboardDatePicker
            disableToolbar
            className={classes.datePicker}
            label="Data final"
            InputLabelProps={{
              style: { color: 'rgba(0, 0, 0, 0.6)' },
            }}
            value={DateTime.fromISO(filters.end_period).toISO()}
            onChange={newDate => handleFilterReferenceDate(newDate, 'end_period')}
            format="dd/MM/yyyy"
            initialFocusedDate={DateTime.local().startOf('day')}
            maxDate={DateTime.local().endOf('year')}
            views={['date']}
          />
        </TableHeader.Input>
      </Box>
    </TableHeader.Filters>
  );
};

BeneficiosMGMParametrosFilters.propTypes = {
  filters: PropTypes.shape({
    contraparte: PropTypes.string,
    statusContratacao: PropTypes.string,
    distribuidora: PropTypes.string,
    inicioContratacao: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  setSelectedFilter: PropTypes.func.isRequired,
};
